import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

import logo from './../../images/sundarban.gif';
import EllipsisList from '../FtrCard/EllipsisList';


const Footer = () => {
    return (
        <div className='ftrBack'>
            <div className="row row-cols-3 row-cols-md-2">
                <div className='mt-5'>
                    <Link to="/">
                        <img style={{ width: '290px', height: '290px',border:"1px solid yellow", marginLeft:"20%" }} src={logo} alt="" />

                    </Link>
                    
                </div>
               
                <div className='text-white mt-3'>
                    <EllipsisList/>
                </div>      
            </div>
            <p className='container ftrTxt'>Copyright 2022 SAVE SHUNDARBANS (TEAM INVINCIBLE) All Rights Reserved</p>
        </div>
    );
};

export default Footer;
